class ProductSelector extends HTMLElement {
    constructor() {
        super();
        this.inputWrapper = "[data-input-wrapper]";
        const LANG = window.localLanguage
        if (LANG == 'en') {
            this.colourLang = 'Color'
        } else {
            this.colourLang = 'Kleur'
        }
        this.variants = JSON.parse(
            this.querySelector('[type="application/json"]').textContent
        );
        this.form = document.querySelector(
            `#ProductForm-${this.dataset.sectionId}`
        );
        this.purchaseOptions = document.querySelector(
            `#Product-Purchase-Options-${this.dataset.sectionId}`
        );
        this.productBar = document.querySelector(
            `#ProductBar-${this.dataset.sectionId}`
        );
        this.installmentsForm = document.querySelector(
            `#Product-Installments-${this.dataset.installmentsFormId}` // check: `${this.dataset.installmentsFormId}`
        );
        this.addEventListener("change", this.onVariantChange);
        // Add delegation for disabled input clicks
        this.addEventListener("click", this.onDisabledInputClick);
        this.updateOptions();
        this.updateVariantStatuses();
        this.updateVariant();

        this.form.toggleAddButton(!this.currentVariant.available, "");
        const saleLabel = document.querySelectorAll("[id=form__sale-label]");
        const saleTag = document.querySelectorAll(".badge.sale");

        if (this.currentVariant?.price < this.currentVariant?.compare_at_price) {
            saleLabel.forEach(element => {
                element.style.display = "block";
            })
            saleTag.forEach(element => {
                element.style.display = "block";
            })
        } else {
            saleLabel.forEach(element => {
                element.style.display = "none";
            })
            saleTag.forEach(element => {
                element.style.display = "none";
            })
        }
    }
    updateVariantStatuses() {
        const inputWrappers = [...this.querySelectorAll(this.inputWrapper)];

        inputWrappers.forEach((option, index) => {
            if (index === 0) return;

            const previousOptionSelected =
                inputWrappers[index - 1].querySelector(":checked").value;

            const filteredVariants = this.variants.filter(
                (variant) =>
                    variant.available && variant[`option${index}`] === previousOptionSelected
            );

            const optionInputs = [
                ...option.querySelectorAll('input[type="radio"], option'),
            ];

            const currentColor = inputWrappers[index - 1]
                .querySelector(":checked")
                .getAttribute("value");

            const variantsForColor = filteredVariants.filter(
                (variant) => variant.option1 === currentColor
            );

            let selectedSize = null;

            optionInputs.forEach((input) => {
                const correspondingVariant = variantsForColor.find(
                    (variant) => variant[`option${index + 1}`] === input.getAttribute("value")
                );

                const inputIsDisabled = !correspondingVariant;

                input.disabled = inputIsDisabled;
                if (input.tagName.toLowerCase() === "option") {
                    input
                        .closest("dropdown-input")
                        .querySelector(`button[data-value="${input.value}"]`).disabled =
                        inputIsDisabled;
                }
                if (!this.productBar) return;
                const inputId = input.dataset.id || input.id;
                const productBarInput = this.productBar.querySelector(
                    `option[data-id="${inputId}"]`
                );
                if (!productBarInput) return;
                productBarInput.disabled = inputIsDisabled;

                input.addEventListener("change", () => {
                    if (input.checked) {
                        selectedSize = input.getAttribute("value");
                    }
                });

                if (input.checked && !input.disabled) {
                    selectedSize = input.getAttribute("value");
                }
            });

            if (!selectedSize) {
                for (const variant of variantsForColor) {
                    const nextOptionValue = variant[`option${index + 1}`];
                    if (nextOptionValue) {
                        selectedSize = nextOptionValue;
                        break;
                    }
                }
            }
            if (selectedSize) {
                const selectedSizeInput = option.querySelector(
                    `input[value="${selectedSize}"]`
                );
                if (selectedSizeInput) {
                    selectedSizeInput.checked = true;
                    if ('createEvent' in document) {
                        let evt = document.createEvent('HTMLEvents');
                        evt.initEvent('change', false, true);
                        selectedSizeInput.dispatchEvent(evt);
                    } else {
                        selectedSizeInput.fireEvent('onchange');
                    }
                }
            }
        });
    }

    onVariantChange(event) {
        if (event.target.type === "number") return;
        this.updateOptions();
        if (this.currentVariant === this.getVariantData()) return;

        this.productBarUpdateOptions();
        this.updateVariant();
        this.updateVariantStatuses();
        this.updatePickupAvailability();
        this.form.removeAttribute("data-has-selling-plan");
        this.form.toggleAddButton(false, "");
        this.form.handleErrorMessage();

        if (!this.currentVariant) {
            this.form.toggleAddButton(true, "");
            this.setUnavailable();

            return;
        }

        if (!this.currentVariant.available) {
            ``;
            this.form.toggleAddButton(true, window.variantStrings.soldOut);
        }

        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();

        const saleLabel = document.querySelectorAll("[id=form__sale-label]");
        const saleTag = document.querySelectorAll(".badge.sale");

        if (this.currentVariant?.price < this.currentVariant?.compare_at_price) {
            saleLabel.forEach(element => {
                element.style.display = "block";
            })
            saleTag.forEach(element => {
                element.style.display = "block";
            })
        } else {
            saleLabel.forEach(element => {
                element.style.display = "none";
            })
            saleTag.forEach(element => {
                element.style.display = "none";
            })
        }
    }

    onVariantClick(event) {

        if (!this.currentVariant.available) {
            console.log('uitberocjt');
        }
    }

     onDisabledInputClick(event) {

        const input = event.target;
        const isActuallyDisabled = input.hasAttribute('disabled') || input.disabled;

        setTimeout(() => {
            const input = event.target.closest('input');

            if (input && input.disabled) {

                // Get current selected options
                const selectedOptions = this.options.map(option => option.value);

                // Find the variant that would be selected if this option were available
                const targetVariant = this.variants.find(variant => {
                    // Match all currently selected options
                    const matchesCurrentSelections = selectedOptions.every((value, index) =>
                        index === this.options.findIndex(opt => opt.name === input.name) ? true : variant.options[index] === value
                    );
                    // Match the clicked disabled option
                    return matchesCurrentSelections && variant.options[this.options.findIndex(opt => opt.name === input.name)] === input.value;
                });

                if (targetVariant) {
                    // Show back-in-stock modal
                    console.log(targetVariant);
                    this.showBackInStockModal(targetVariant);
                }
            }
        }, 500);
    }

    showBackInStockModal(variant) {
        // Create modal container
        const modalContainer = document.createElement('div');
        modalContainer.className = 'back-in-stock-modal';
        modalContainer.style.position = 'fixed';
        modalContainer.style.top = '0';
        modalContainer.style.left = '0';
        modalContainer.style.width = '100%';
        modalContainer.style.height = '100%';
        modalContainer.style.backgroundColor = 'rgba(0,0,0,0.5)';
        modalContainer.style.zIndex = '9999';
        modalContainer.style.display = 'flex';
        modalContainer.style.justifyContent = 'center';
        modalContainer.style.alignItems = 'center';

        // Create modal content
        const modalContent = document.createElement('div');
        modalContent.className = 'back-in-stock-modal-content';
        modalContent.style.backgroundColor = '#fff';
        modalContent.style.padding = '24px 32px';
        modalContent.style.borderRadius = '5px';
        modalContent.style.maxWidth = '400px';
        modalContent.style.width = '100%';

        // Get language and set text accordingly
        const LANG = document.documentElement.lang || 'en';
        let modalTitle, modalDescription, emailLabel, cancelButton, submitButton;

        if (LANG === 'nl') {
            modalTitle = 'Ontvang een melding wanneer weer op voorraad';
            modalDescription = 'Dit artikel is momenteel niet beschikbaar. Vul je e-mail in om een melding te ontvangen wanneer het weer beschikbaar is.';
            emailLabel = 'E-mail';
            cancelButton = 'Annuleren';
            submitButton = 'Houd mij op de hoogte';
        } else {
            modalTitle = 'Get notified when back in stock';
            modalDescription = 'This item is currently unavailable. Enter your email to be notified when it becomes available.';
            emailLabel = 'Email';
            cancelButton = 'Cancel';
            submitButton = 'Notify Me';
        }

        // Create form
        const form = document.createElement('form');
        form.className = 'back-in-stock-form';
        form.innerHTML = `
            <h3 style="margin-top: 0;">${modalTitle}</h3>
            <p>${modalDescription}</p>
            <div style="margin-bottom: 15px;">
                <label for="bis-email" style="display: block; margin-bottom: 5px;">${emailLabel}</label>
                <input type="email" id="bis-email" placeholder="Uw emailadres" required style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
            </div>
            <div style="display: flex; justify-content: space-between;">
                <button type="button" class="bis-cancel" style="padding: 8px 15px; border: 1px solid #ddd; background: #f5f5f5; border-radius: 4px; cursor: pointer;">${cancelButton}</button>
                <button type="submit" style="padding: 8px 15px; background: #000; color: white; border: none; border-radius: 4px; cursor: pointer;">${submitButton}</button>
            </div>
        `;

        // Add form submission handler
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = form.querySelector('#bis-email').value;
            this.submitBackInStockRequest(email, variant.id);
            modalContainer.remove();
        });

        // Add cancel button handler
        form.querySelector('.bis-cancel').addEventListener('click', () => {
            modalContainer.remove();
        });

        // Add click outside to close
        modalContainer.addEventListener('click', (e) => {
            // If the click is directly on the modalContainer (overlay) and not on its children
            if (e.target === modalContainer) {
                modalContainer.remove();
            }
        });

        // Add escape key to close
        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                modalContainer.remove();
                document.removeEventListener('keydown', handleEscapeKey);
            }
        };
        document.addEventListener('keydown', handleEscapeKey);

        // Assemble and add to DOM
        modalContent.appendChild(form);
        modalContainer.appendChild(modalContent);
        document.body.appendChild(modalContainer);

        // Focus the email input for better UX
        setTimeout(() => {
            const emailInput = modalContainer.querySelector('#bis-email');
            if (emailInput) emailInput.focus();
        }, 100);
    }

    submitBackInStockRequest(email, variantId) {
        // Prepare data for Klaviyo API
        const options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2024-07-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: email
                                }
                            }
                        },
                        channels: ["EMAIL"]
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: `$shopify:::$default:::${variantId}`
                            }
                        }
                    }
                }
            })
        };

        // Get Klaviyo account ID from settings or use default
        const klaviyoAccountId = window.klaviyoAccountId || 'SbRz6Y';

        // Get language for notifications
        const LANG = document.documentElement.lang || 'en';
        let successMessage, errorMessage;

        if (LANG === 'nl') {
            successMessage = 'Gelukt! We sturen je een melding wanneer dit artikel weer op voorraad is.';
            errorMessage = 'Er is iets misgegaan. Probeer het opnieuw.';
        } else {
            successMessage = 'Success! We\'ll notify you when this item is back in stock.';
            errorMessage = 'Something went wrong. Please try again.';
        }

        // Submit to Klaviyo API
        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoAccountId}`, options)
            .then(response => {
                if (response.ok) {
                    // Track successful subscription in Klaviyo
                    if (window._learnq) {
                        window._learnq.push(['identify', {
                            '$email': email,
                            'Language': document.documentElement.lang
                        }]);
                    }

                    // Show success message
                    this.showNotification(successMessage, 'success');
                } else {
                    // Show error message
                    this.showNotification(errorMessage, 'error');
                    console.error('Back in stock subscription failed:', response);
                }
            })
            .catch(err => {
                this.showNotification(errorMessage, 'error');
                console.error('Back in stock API error:', err);
            });
    }

    showNotification(message, type) {
        const notification = document.createElement('div');
        notification.className = `notification notification-${type}`;
        notification.textContent = message;
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.right = '20px';
        notification.style.marginLeft = '20px';
        notification.style.padding = '10px 20px';
        notification.style.borderRadius = '4px';
        notification.style.color = 'white';
        notification.style.backgroundColor = type === 'success' ? '#178027' : '#ff6b6b';
        notification.style.zIndex = '10000';

        document.body.appendChild(notification);

        setTimeout(() => {
            notification.remove();
        }, 5000);
    }

    updateOptions() {
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.nextElementSibling.classList.toggle("is-active", input.checked);
        });
        this.options = Array.from(
            this.querySelectorAll('input[type="radio"]:checked, select'),
            (el) => ({name: el.dataset.name || el.name, value: el.value})
        );
        const colorLabel = document.querySelector(".form__color-label");
        colorLabel.textContent = `${this.colourLang}: ${this.options[0].value}`;

    }

    productBarUpdateOptions() {
        Array.from(this.productBar.querySelectorAll("select")).map((selector) => {
            selector.value = this.options.find(
                (option) => option.name === selector.name
            ).value;
        });
    }

    updatePickupAvailability() {
        const pickUpAvailabilityNode = document.querySelector(
            "pickup-availability"
        );

        if (!pickUpAvailabilityNode || !this.currentVariant) return;

        pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailabilityNode.setAttribute("available", "");
            pickUpAvailabilityNode.fetchAvailability(
                pickUpAvailabilityNode.dataset.variantId
            );

            return;
        }

        pickUpAvailabilityNode.removeAttribute("available");
        pickUpAvailabilityNode.innerHTML = "";
    }

    updateVariant() {
        this.currentVariant = this.getVariantData();
    }

    getVariantData() {
        return this.options.length
            ? this.variants.find((variant) => {
                return !variant.options
                    .map((option, index) => this.options[index].value === option)
                    .includes(false);
            })
            : this.variants[0];

    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;

        const productMedia = document.querySelector("product-media");
        productMedia.setActiveMedia(this.currentVariant.featured_media.id);
    }

    updateURL(sellingPlanId) {
        if (!this.currentVariant) return;
        const params = new URLSearchParams(window.location.search);
        params[params.has("variant") ? "set" : "append"](
            "variant",
            this.currentVariant.id
        );
        if (sellingPlanId) {
            params[params.has("selling_plan") ? "set" : "append"](
                "selling_plan",
                sellingPlanId
            );
        } else {
            params.delete("selling_plan");
        }
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?${params.toString()}`
        );
    }

    updateVariantInput() {
        const inputs = [
            this.querySelector('[name="id"'),
            this.installmentsForm?.querySelector('[name="id"]'),
        ];
        inputs.forEach((input) => {
            if (!input) return;
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", {bubbles: true}));
        });
        // console.log(this.installmentsForm);
    }

    setUnavailable() {
        const submitButton = this.form.submitButton;
        const price = this.querySelector(
            `#Product-Price-${this.dataset.sectionId}`
        );

        if (!submitButton) return;
        submitButton.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
    }

    renderProductInfo() {
        const params = new URLSearchParams(window.location.search);
        params[params.has("variant") ? "set" : "append"](
            "variant",
            this.currentVariant.id
        );
        params.append("section_id", this.dataset.sectionId);

        fetch(`${this.dataset.url}?${params.toString()}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                [
                    `#Product-Price-${this.dataset.sectionId}`,
                    `#Product-Purchase-Options-${this.dataset.sectionId}`,
                ].map((liveRegionSelector) => {
                    const destination = document.querySelector(liveRegionSelector);
                    const source = html.querySelector(liveRegionSelector);

                    const inventory = document.getElementById(
                        `inventory-display-${this.dataset.sectionId}`
                    );

                    if (inventory)
                        inventory.classList.remove("visibility-hidden"),
                            this.updateInventory(html);

                    if (destination && source) {
                        destination.classList.remove("visibility-hidden");
                        destination.innerHTML = source.innerHTML;
                    }
                });
            });
    }

    updateInventory(html) {
        const id = `inventory-display-${this.dataset.sectionId}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
    }

     onDisabledInputClick(event) {
        const target = event.target;
        const productElement = target.closest('.js-product');
  
        if (productElement) {
            const isOutOfProduction = productElement.dataset.outOfProduction === 'true';
    
            if (!isOutOfProduction) {


        const input = event.target;
        const isActuallyDisabled = input.hasAttribute('disabled') || input.disabled;

        setTimeout(() => {
            const input = event.target.closest('input');

            if (input && input.disabled) {

                // Get current selected options
                const selectedOptions = this.options.map(option => option.value);

                // Find the variant that would be selected if this option were available
                const targetVariant = this.variants.find(variant => {
                    // Match all currently selected options
                    const matchesCurrentSelections = selectedOptions.every((value, index) =>
                        index === this.options.findIndex(opt => opt.name === input.name) ? true : variant.options[index] === value
                    );
                    // Match the clicked disabled option
                    return matchesCurrentSelections && variant.options[this.options.findIndex(opt => opt.name === input.name)] === input.value;
                });

                if (targetVariant) {
                    // Show back-in-stock modal
                    console.log(targetVariant);
                    this.showBackInStockModal(targetVariant);
                }
            }
        }, 500);
            }
        }
    }
}

customElements.define("product-selector", ProductSelector);
